import { namespaceType } from './namespace';

const productsListType = namespaceType('productsList');
const productType = namespaceType('product');
const structaProductLevel1Type = namespaceType('structaProductLevel1');
const articlesListType = namespaceType('articlesList');
const articleType = namespaceType('article');
const documentPageType = namespaceType('documentPage');
const faqsType = namespaceType('faqs');
const contactUsType = namespaceType('contactUs');
const storeLocatorType = namespaceType('storeLocator');
const homePageType = namespaceType('homePage');

export const computedInternalUrl = `
  select(
    defined(parentPage->parentPage->slug.current) => "/products/" + parentPage->parentPage->slug.current + "/" + parentPage->slug.current + "/" + slug.current,
    defined(parentPage->slug.current) => "/products/" + parentPage->slug.current + "/" + slug.current,
    _type == "${productsListType}" => "/products/" + category->slug.current + "/" + slug.current,
    _type == "${productType}" && defined(subcategory->parentCategory->slug.current) => "/products/" + subcategory->parentCategory->slug.current + "/" + subcategory->slug.current + "/" + slug.current,
    _type == "${structaProductLevel1Type}" => "/products/" + slug.current,
    _type == "${articlesListType}" => "/" + select(
      type == "blogs" => "blog",
      type
    ),
    _type == "${articleType}" && defined(type) && type == "blogs" => "/blog/" + slug.current,
    _type == "${articleType}" && defined(type) => "/" + type + "/" + slug.current,
    _type == "${documentPageType}" => "/documents/" + slug.current,
    _type == "${faqsType}" => "/faq",
    _type == "${contactUsType}" => "/contact-us",
    _type == "${storeLocatorType}" => "/store-locator",
    _type == "${homePageType}" => "/",
    "/" + slug.current
  )
`;

export const internalReferenceUrl = `
  select(
    type == "internal" =>
      internalReference->{
        "computedUrl": ${computedInternalUrl}
      }.computedUrl,
    url
  )
`;

export const directInternalReferenceUrl = `
  select(
    link.type == "internal" =>
      link.internalReference->{
        "computedUrl": ${computedInternalUrl}
      }.computedUrl,
    link.url
  )
`;

export const LOGO_PROJECTTION = `
  logo{
    ...,
    link{
      ...,
      "url": ${internalReferenceUrl},
    },
    "imageUrl": logo.asset->url,
  }
`;

export const imageProjection = `
  ...,
  "alt": coalesce(alt, asset->altText),
  "title": coalesce(title, asset->title),
  "url": asset->url,
`;
